import { defer } from 'react-router-dom'
import { isAppStateReady } from 'src/state/store'
import { logger } from '$utils'
import useRosterStore from '../store'

export default async function loader({ params }) {
  logger.debug(
    '[loader] About to await AppState being ready in Publish Roster loader'
  )
  await isAppStateReady()
  logger.debug('[loader] AppState should now be ready in Publish Roster loader')

  const getRoster = useRosterStore
    .getState()
    .getRosterById(params.rosterId)
    .then(async (roster) => {
      if (!roster) return

      const uniqueStaffMemberIds = new Set<string>()

      roster.rosteredShifts.forEach((shift) => {
        uniqueStaffMemberIds.add(shift.staffMemberId)
      })

      // We want to include the deleted staff memebers so we can show them
      // in the publish and re publish flows
      return useRosterStore
        .getState()
        .getStaffMembersLinkedToRoster(true, roster)
    })

  return defer({
    data: Promise.all([getRoster])
      .then(() => true)
      .catch((error) => {
        logger.error('Publish Roster Promise.all error', error)
        return false
      }),
  })
}
